import { SharedStationIcon } from '@app/components/stations/SharedStationIcon';
import { YoutubeNativeStationIcon } from '@app/components/stations/YoutubeNativeStationIcon';
import { Station } from '@mi-front/core';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, Chip, ChipProps } from '@mui/material';
import { StationAvatar } from './StationAvatar';

export interface StationsNavigatorLinkProps {
  readonly station: Station | undefined;
  readonly onClick: () => void;
  readonly size?: ChipProps['size'];
}

export const StationsNavigatorLink = (props: StationsNavigatorLinkProps) => {
  const { station, onClick, size = 'medium' } = props;

  if (!station) {
    return null;
  }

  return (
    <Chip
      variant="outlined"
      size={size}
      avatar={<StationAvatar stationId={station.id} />}
      label={
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <Box component="span">{station.name}</Box>
          <YoutubeNativeStationIcon station={station} size={size} />
          <SharedStationIcon station={station} size={size} />
        </Box>
      }
      onClick={onClick}
      onDelete={onClick}
      deleteIcon={<ArrowDropDownIcon />}
      clickable
    />
  );
};
